import { useSnippetsPermissions } from '../../../features/teams';

export const useSnippetsActions = () => {
  const { isCanCreatePersonalSnippets, isCanManageSnippets } =
    useSnippetsPermissions();

  const isCanManageOrCreatePersonalSnippets =
    isCanManageSnippets || isCanCreatePersonalSnippets;

  return {
    isCanManageOrCreatePersonalSnippets,
  };
};
